define(
'shared/initializer/form/adapters/mixins/PlaceholderEnableable',[
    '$',
    'shared/lib/RSVP',
    'shared/lib/kongr'
], 
function ($, RSVP, $kongr) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function() {
        var $form = this.$form;

        return new RSVP.Promise(function(resolve){
            $(function(){
                $form.find('input, textarea').kongr();
                resolve();
            });
        });
    };

    return Ctor;
});
